import { ArrowCircleUp, ArrowCircleUpTwoTone } from "@mui/icons-material";
import { Box, ButtonBase, Fade, IconButton, Slide, useMediaQuery, useScrollTrigger } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';

export default function LogoMobile() {
   // Setup scroll triggers
   const isScrolledMobile = useScrollTrigger({ disableHysteresis: true, threshold: 100 });

   return (
      <Box sx={{ display: 'flex', justifyContent: 'end', bgcolor: "kr.main", paddingTop: '40px', paddingRight: '40px' }} >
         <ButtonBase component={RouterLink} to="/">
            <img src="/img/logo.png" style={{ height: "150px" }} />
         </ButtonBase>
         <Fade in={isScrolledMobile}>
            <Box
               onClick={() => window.scrollTo(0, 0)}
               role="presentation"
               sx={{ position: 'fixed', bottom: 0, right: 0, zIndex: 10 }}
            >
               <IconButton sx={{ zIndex: 1000 }}><ArrowCircleUp fontSize="large" ></ArrowCircleUp></IconButton>
            </Box>
         </Fade>
      </Box>
   );
}